import React from "react";
import TeamMember from "../team-member";
import { getImage } from "../../contentful/data-provider";
import { renderRichText } from "gatsby-source-contentful/rich-text";

export default function TeamMembersSection({ content }) {
	if (content.downloadPictures) {
		return (
			<section className='mt-0 member'>
				<div className='container'>
					<div className='pt-5 row'>
						<div className='col-12 col-md-8 col-lg-5'>
							<h2>{content.title}</h2>
							{renderRichText(content.body)}
						</div>
					</div>
					<div className='row'>
						{content.elements.map((teamMember, index) => {
							return (
								<div className='px-2 py-4 col-12 col-sm-6 col-lg-4' key={index}>
									<div className={"member"}>
										<div className='image'>
											<img src={getImage(teamMember.image).url} alt={teamMember.name} />
										</div>
										<div className='name'>
											<div className='mt-3 row align-items-center justify-content-between'>
												<div className='col-12 col-md'>
													<div className='title'>{teamMember.name}</div>
													<div className='subtitle'>{teamMember.position}</div>
												</div>
												<div className='col-12 col-md-auto text-md-right'>
													<a
														href={getImage(teamMember.image).url}
														className='btn btn--small'
														role='button'
														download={`${(teamMember.name + "-" + teamMember.position).replaceAll(" ", "_")}-Agoric`}
													>
														Download
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</section>
		);
	}
	return (
		<section key={content.id} className={"team-members-section"}>
			<div className='container'>
				<div className='row team--content align-items-center'>
					<div className='py-5 col-lg-4 col-sm-12 pr-lg-5'>
						<h2 className='mb-2'>{content.title}</h2>
						{renderRichText(content.body)}
						<svg className='red-arrow' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 19'>
							<path
								d='M50.867 18.133c.13 0 .235-.04.313-.117l8.164-8.203A.371.371 0 0 0 59.5 9.5a.371.371 0 0 0-.156-.312L51.18.984a.422.422 0 0 0-.313-.117c-.13 0-.247.04-.351.117l-.782.782a.422.422 0 0 0-.117.312c0 .13.04.248.117.352l6.055 6.054H.537c-.13 0-.241.046-.332.137a.452.452 0 0 0-.137.332v1.094c0 .13.045.24.137.332a.452.452 0 0 0 .332.137h55.252l-6.055 6.054a.571.571 0 0 0-.117.352c0 .13.04.234.117.312l.782.782a.571.571 0 0 0 .351.117Z'
								fill='#D73252'
								fill-rule='nonzero'
							/>
						</svg>
					</div>
					{content.elements.map((teamMember, index) => {
						return (
							<div className='col-lg-4 col-sm-6' key={index}>
								<TeamMember content={teamMember} />
							</div>
						);
					})}
				</div>
			</div>
		</section>
	);
}
